"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LockBackground = exports.StyledModalWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  body {\n    overflow: hidden;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledModalWrapper = _styledComponents.default.div.withConfig({
  displayName: "ModalWrapperstyles__StyledModalWrapper",
  componentId: "sc-5m77bq-0"
})(["&.c-modal-wrapper-modal-wrapper{position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;background-color:", ";-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:flex;text-align:center;vertical-align:middle;}.centering-wrapper{margin:0 auto;width:100%;}.c-modal-wrapper-modal{background-color:", ";border-radius:", ";height:auto;margin-top:", ";margin-right:", ";margin-bottom:", ";marging-left:", ";max-height:85vh;overflow:auto;@media only screen and (min-width:", "){margin-top:", ";margin-right:auto;margin-bottom:", ";margin-left:auto;width:", ";}}&.c-modal-wrapper-in-style-guide{position:relative;height:100%;}.c-modal-wrapper-modal-header{background-color:", ";color:", ";height:3rem;position:relative;display:flex;flex-direction:row;justify-content:center;box-sizing:border-box;padding:0 1rem;@media only screen and (min-width:", "){border-radius:3px 3px 0 0;}.c-modal-wrapper-title{flex:1 1 100%;font-weight:", ";text-align:left;color:", ";line-height:3rem;white-space:nowrap;padding:auto 0;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:center;width:100%;@media only screen and (min-width:", "){width:auto;}}.c-modal-wrapper-top-bar-icon{flex:0 1 0;height:100%;outline:none;cursor:default;padding:.5rem 1rem .5rem 0;}.c-modal-wrapper-close-button{cursor:pointer;padding-right:0;padding-left:.5rem;}}.c-modal-wrapper-modal-content{padding:1.25rem;text-align:left;line-height:.6rem;overflow-y:scroll;max-height:70vh;}.c-modal-wrapper-alert-choice{max-width:100%;height:auto;margin:0 ", ";border-radius:", ";@media only screen and (min-width:", "){width:", ";max-height:50rem;height:auto;margin:0 auto;border-radius:", ";}}"], function (props) {
  return props.theme.menu;
}, function (props) {
  return props.theme.c_mask_modal;
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.standardPadding, props.theme.mobileMenuHeight);
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.standardPadding, props.theme.mobileMenuHeight);
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.componentSizeLarge;
}, function (props) {
  switch (props.modalRole) {
    case 'alert':
      return props.theme.c_foreground_warning;

    case 'info':
      return props.theme.c_foreground_info;

    default:
      return props.theme.c_foreground_primary;
  }
}, function (props) {
  switch (props.modalRole) {
    case 'alert':
      return props.theme.c_foreground_default;

    default:
      return props.theme.c_foreground_overDark;
  }
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  switch (props.modalRole) {
    case 'alert':
      return props.theme.c_foreground_default;

    default:
      return props.theme.c_foreground_overDark;
  }
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.mobileGutter;
}, function (props) {
  return props.theme.borderRadiusWide;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.componentSizeLarge;
}, function (props) {
  return props.theme.borderRadiusWide;
});

exports.StyledModalWrapper = StyledModalWrapper;
var LockBackground = (0, _styledComponents.createGlobalStyle)(_templateObject());
exports.LockBackground = LockBackground;